var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAlphabeticalVariant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sort-alphabetical-variant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.25016 5L12.5002 1.75L15.7502 5H9.25016ZM15.7502 19L12.5002 22.25L9.25016 19H15.7502ZM8.89016 14.3H6.00016L5.28016 17H2.91016L6.00016 7H9.00016L12.1302 17H9.67016L8.89016 14.3ZM6.33016 12.68H8.56016L7.93016 10.56L7.67016 9.59L7.42016 8.63H7.39016L7.17016 9.6L6.93016 10.58L6.33016 12.68ZM13.0502 17V15.74L17.8002 8.97V8.91H13.5002V7H20.7302V8.34L16.0902 15V15.08H20.8002V17H13.0502Z",
    fill: "#555555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAlphabeticalVariant);
export default __webpack_public_path__ + "static/media/sort-alphabetical-variant.93c97db3db4f634850e60b296e3a5860.svg";
export { ForwardRef as ReactComponent };